import { styled } from "../../../stitches.config"

export const UnorderedList = styled("ul", {
  length: 0,
  backgroundColor: "$slate4",
  borderRadius: "10px",
  color: "$slate11",
  fontSize: "$sm",
  lineHeight: "$500",
  listStyleType: "disc",
  marginBottom: "$2",
  marginTop: "$2",
  marginRight: "$2",
  paddingRight: "$6",
  paddingLeft: "$8",
  paddingTop: "$3",
  paddingBottom: "$2",
}
)
